import Swiper, {Navigation, Pagination} from "swiper";

export function initTabs($tabs) {
    if (!$tabs) return;

    var defaultTab = $tabs.attr('data-default-tab');
    if (!defaultTab) {
        defaultTab = $tabs.find('[data-tab]').first().attr('data-tab');
    }

    changeTab(defaultTab);

    $tabs.on('click', '.switch', function () {
        if ($(this).hasClass('active')) return false;

        //для главной страницы выключаем переключатель на мобилке
        if ($tabs.hasClass('tournament-tables') && window.innerWidth < 768) return false;
        changeTab($(this).attr('data-tab'));

        return false;
    });

    function changeTab(tab) {
        $tabs.find('[data-tab]').removeClass('active');
        $tabs.find('[data-tab="' + tab + '"]').addClass('active');
    }
}

export function initHashNavigation() {
    setTimeout(function () {
        let hash = window.location.hash || '';
        hash = hash.replace('#', '');
        if (hash.includes('photo')) return;

        scrollToElement(hash);
    }, 500);


    $(window).on('hashchange', function () {
        var hash = location.hash || '';
        if (hash.includes('photo')) return;

        hash = hash.replace('#', '');
        scrollToElement(hash);
    });

    function scrollToElement(hash) {
        if (!hash) return;

        const $element = $('[data-hash=' + hash + ']:visible');
        if (!$element.length) return;
        if ($element.hasClass('.swiper-slide').length) return;
        if ($('[href="#' + hash + '"]').hasClass('disabled')) return;

        const elementTop = +$element.offset().top;
        let headerHeight = 0;

        let top = elementTop - headerHeight;

        $('html, body').animate({
            scrollTop: top - 25
        }, 500);
    }
}

export function updateViewportHeight() {
    if ($(document).width() < 1000) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
    } else {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
    }
}

export function initFullWideSwiper() {
    return new Swiper('.full-wide-slide-swiper', {
        speed: 300,
        modules: [Navigation, Pagination],
        pagination: {
            el: '.full-wide-pagination',
            type: 'bullets',
            clickable: true
        },
        navigation: {
            nextEl: '.full-wide-slide-next',
            prevEl: '.full-wide-slide-prev'
        },
    });
}

export function checkPosition(element, functionsArr) {
    const scroll = $(window).scrollTop() + $(window).height();
    const offset = element.offset().top + element.height();

    if (scroll > offset) {
        $.each(functionsArr, function (i, val) {
            val();
        });
    }
}


export function getHalfViewPortHeight() {
    return $(window).height() / 2;
}

export function initResizeNewsItems() {
    if ($('.flex-grid.tiles-grid.news').length) {
        resizeNewsItems();

        $(window).on('resize', () => {
            resizeNewsItems();
        });
    }

    function resizeNewsItems(){
        const $items = $('.item.item-small');
        const $bigItem = $('.item.item-big');
        const bigItemWidth = $bigItem.width();

        $items.each((_, item) => {
            const itemWidth = $(item).width();

            if (window.innerWidth > 759) {
                $(item).css('min-height', `${Math.ceil(itemWidth / 1.78)}px`);

            } else {
                $(item).css('min-height', `102px`);
            }
        });

        if(window.innerWidth < 1000){
            $bigItem.css('min-height', `${Math.ceil(bigItemWidth / 1.78)}px`);

        }else{
            if($('.section.match-screen').length){
                $bigItem.css('min-height', `${Math.ceil(bigItemWidth / 1.78)}px`);
            }else{
                $bigItem.css('min-height', `unset`);
            }
        }
    }
}

export function translator(word, lang) {
    return dictionary[word][lang]
}

const dictionary = {
    'Билеты': {
        'ru': 'Билеты',
        'en': 'Tickets'
    },
    'Абонементы': {
        'ru': 'Абонементы',
        'en': 'Subscriptions'
    },
    'В случае если Ваш банк поддерживает технологию безопасного проведения интернет-платежей Verified By Visa или MasterCard Secure Code, для проведения платежа также может потребоваться ввод специального пароля. Способы и возможность получения паролей для совершения интернет-платежей Вы можете уточнить в банке, выпустившем карту.': {
        'ru': 'В случае если Ваш банк поддерживает технологию безопасного проведения интернет-платежей Verified By Visa или MasterCard Secure Code, для проведения платежа также может потребоваться ввод специального пароля. Способы и возможность получения паролей для совершения интернет-платежей Вы можете уточнить в банке, выпустившем карту.',
        'en': 'If your bank supports the technology of secure online payments Verified By Visa or MasterCard Secure Code, you may also need to enter a special password to make a payment. You can check the methods and the possibility of obtaining passwords for making Internet payments at the bank that issued the card.'
    },
    'Настоящий сайт поддерживает 256-битное шифрование. Конфиденциальность сообщаемой персональной информации обеспечивается ПАО «Сбербанк России». Введенная информация не будет предоставлена третьим лицам за исключением случаев, предусмотренных законодательством РФ. Проведение платежей по банковским картам осуществляется в строгом соответствии с требованиями платежных систем Visa Int. и MasterCard Europe Sprl.': {
        'ru': 'Настоящий сайт поддерживает 256-битное шифрование. Конфиденциальность сообщаемой персональной информации обеспечивается ПАО «Сбербанк России». Введенная информация не будет предоставлена третьим лицам за исключением случаев, предусмотренных законодательством РФ. Проведение платежей по банковским картам осуществляется в строгом соответствии с требованиями платежных систем Visa Int. и MasterCard Europe Sprl.',
        'en': 'This site supports 256-bit encryption. The confidentiality of the reported personal information is provided by Sberbank of Russia PJSC. The entered information will not be provided to third parties, except as provided by the legislation of the Russian Federation. Payments by bank cards are carried out in strict accordance with the requirements of Visa Int payment systems. and MasterCard Europe Sprl.'
    },
    'Уважаемый болельщик': {
        'ru': 'Уважаемый болельщик',
        'en': 'Dear fan'
    },
    'Допустима продажа до 4-х сезонных билетов на одну учетную регистрационную запись': {
        'ru': 'Допустима продажа до 4-х сезонных билетов на одну учетную регистрационную запись',
        'en': 'Up to 4 season tickets can be sold per registration account'
    },
    'Допустима продажа до 20 билетов на одну учетную регистрационную запись': {
        'ru': 'Допустима продажа до 20 билетов на одну учетную регистрационную запись',
        'en': 'Up to 20 tickets can be sold per registration account'
    },
    'тур': {
        'ru': 'тур',
        'en': 'tour'
    },
    'Сезон': {
        'ru': 'Сезон',
        'en': 'Season'
    },
    'Дата будет известна позднее': {
        'ru': 'Дата будет известна позднее',
        'en': 'Date will be known later'
    },
    'Сегодня': {
        'ru': 'Сегодня',
        'en': 'Today'
    },
    'Завтра': {
        'ru': 'Завтра',
        'en': 'Tomorrow'
    },
    'Купить': {
        'ru': 'Купить',
        'en': 'Buy'
    },
    'Уважаемые болельщики': {
        'ru': 'Уважаемые болельщики',
        'en': 'Dear fans'
    },
    'Совсем скоро вы вновь сможете приобрести сезонные абонементы на матчи «Крыльев Советов». Пока у вас есть возможность оформить карту болельщика, которая будет необходима для покупки билетов и абонементов и посещения стадиона.': {
        'ru': 'Совсем скоро вы вновь сможете приобрести сезонные абонементы на матчи «Крыльев Советов». Пока у вас есть возможность оформить карту болельщика, которая будет необходима для покупки билетов и абонементов и посещения стадиона.',
        'en': 'Very soon you will again be able to purchase season tickets for Krylya Sovetov matches. For now, you have the opportunity to get a fan card, which will be needed to buy tickets and season tickets and visit the stadium.'
    },
    'Карту болельщика можно оформить на сайте': {
        'ru': 'Карту болельщика можно оформить на сайте',
        'en': 'A fan card can be issued on the website'
    },
    'Госуслуг': {
        'ru': 'Госуслуг',
        'en': 'Gosuslug'
    },
    'Что-то пошло не так': {
        'ru': 'Что-то пошло не так',
        'en': 'Something went wrong'
    },
    'Попробовать снова': {
        'ru': 'Попробовать снова',
        'en': 'Something went wrong'
    },
    'Билетов нет': {
        'ru': 'Билетов нет',
        'en': 'No tickets'
    },
    'В продаже с': {
        'ru': 'В продаже с',
        'en': 'On sale from'
    },
    'Абонементов нет': {
        'ru': 'Абонементов нет',
        'en': 'No season tickets'
    },
    'При покупке билета на этот матч, вы получите скидку 50% на матч': {
        'ru': 'При покупке билета на этот матч, вы получите скидку 50% на матч',
        'en': 'When buying a ticket for this match, you will receive a 50% discount on the match'
    },
    'СЕЗОННЫЙ БИЛЕТ': {
        'ru': 'СЕЗОННЫЙ БИЛЕТ',
        'en': 'SEASON TICKET'
    }
}
